import React from 'react';
import { IconProps } from '../types/types';

const VELO: React.FC<IconProps> = (props) => (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#DA1A5E"/><path d="M11.722 11.427 7.186 6.891a2.108 2.108 0 0 0-2.981 0h-.001a2.108 2.108 0 0 0 0 2.982L8.74 14.41a2.108 2.108 0 0 0 2.982-2.982ZM14.38 10.492a2.108 2.108 0 1 0 0-4.217 2.108 2.108 0 0 0 0 4.217Z" fill="#fff"/></svg>
);

export default VELO;
